const noop = () => { };
/**
 * Аналог стандартному [`Promise.withResolvers`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers)
 *
 * @export
 * @template T
 * @return {{ promise: Promise<T>; resolve: (val: T) => void; reject: (err?: Error) => void }}
 */
function withResolvers() {
    let resolve = noop;
    let reject = noop;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return { promise, resolve, reject };
}

export { withResolvers };
//# sourceMappingURL=promise.js.map
